import { ReactElement } from 'react'

import classNames from 'classnames'
import { ErrorMessage } from 'formik'

import { IconButton } from 'components/Buttons'
import { Flex } from 'components/core'
import { TrashIcon } from 'components/Icons'

import { ColumnConfig, BaseKeyword } from './localTypes'
import * as styles from './styles.scss'

interface Props<KeywordField> {
    keyword: KeywordField
    keywordIndex: number
    remove: (index: number) => void
    columnsConfig: ColumnConfig[]
}

function CreateKeywordFormRow<KeywordField extends BaseKeyword>({
    keyword,
    keywordIndex,
    remove,
    columnsConfig,
}: Props<KeywordField>): ReactElement {
    return (
        <Flex
            alignItems="start"
            className={styles['keyword-row']}
            marginTop={8}
            style={{ paddingBottom: 8 }}
        >
            <div
                style={{ flex: 1, marginRight: 4 }}
                className={styles['text-field']}
            >
                {keyword.text}
            </div>
            {columnsConfig.map(({ dataKey, width, renderField }) => {
                const fieldName = `keywords.${keywordIndex}.${dataKey}`
                return (
                    <Flex
                        direction="column"
                        className={styles.field}
                        marginRight={4}
                        style={{ width }}
                        key={dataKey}
                    >
                        {renderField(fieldName)}
                        <ErrorMessage
                            name={fieldName}
                            component="div"
                            className="fg-control-text is-error"
                        />
                    </Flex>
                )
            })}

            <Flex
                direction="column"
                className={classNames(styles.field, styles['remove-column'])}
                marginRight={4}
            >
                <IconButton
                    icon={<TrashIcon />}
                    danger
                    type="link"
                    onClick={() => {
                        remove(keywordIndex)
                    }}
                />
            </Flex>
        </Flex>
    )
}

export default CreateKeywordFormRow
